const Divider = () => (
    <div className="divider-container">
    <div className="divider-line"></div>
    <span className="divider-text">OU</span>
    <div className="divider-line"></div>
  </div>
  );
  export default Divider